import './App.css';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Topbar from './components/Topbar';
import Footer from './components/Footer';
import Header from './components/Header';
import PageBanner from './components/PageBanner';

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Clients = lazy(() => import('./pages/Clients'));
const Career = lazy(() => import('./pages/Internship'));
const Contact = lazy(() => import('./pages/Contact'));
const Products = lazy(() => import('./pages/Products'));
const Services = lazy(() => import('./pages/Services'));
const AboutIntro = lazy(() => import('./pages/AboutIntro'));
const VisionMission = lazy(() => import('./pages/VisionMission'));
const LeaderShip = lazy(() => import('./pages/Leadership'));
const OurCommitment = lazy(() => import('./pages/OurCommitment'));
const SangerSequence = lazy(() => import('./pages/SangerSequence'));
const MicrobialIdentity = lazy(() => import('./pages/MicrobialIdentity'));
const DNABarcoding = lazy(() => import('./pages/DNABarcoding'));
const GeneExpression = lazy(() => import('./pages/GeneExpression'));
const CattleGenotyping = lazy(() => import('./pages/CattleGenotyping'));
const GeneSynthesis = lazy(() => import('./pages/GeneSynthesis'));
const UNModifiedOligo = lazy(() => import('./pages/UNModifiedOligo'));
const ModifiedOligo = lazy(() => import('./pages/ModifiedOligo'));
const DNAAuthenticity = lazy(() => import('./pages/DNAAuthenticity'));
const ReagentsKits = lazy(() => import('./pages/ReagentsKits'));
const SequenceOrderForm = lazy(() => import('./pages/SequenceOrderForm'));
const OligosOrderForm = lazy(() => import('./pages/OligosOrderForm'));
const NewsUpdates = lazy(() => import('./pages/NewsUpdates'));
const VideoGallery = lazy(() => import('./pages/VideoGallery'));
const ValueProposition = lazy(() => import('./pages/ValueProposition'));
const SangerSequenceing = lazy(() => import('./pages/SangerSequenceing'));
const GenomicInformation = lazy(() => import('./pages/GenomicInformation'));
const GisMIDOrderForm = lazy(() => import('./pages/GisMIDOrderForm'));
const Downloads = lazy(() => import('./pages/Downloads'));

const PageLoader = () => (
  <div style={{ padding: '2rem', textAlign: 'center', fontSize: '1rem', color: '#0d47a1' }}>
    Loading...
  </div>
);

function App() {
  return (
    <Router>
      <Header />
      <Topbar />
      <Navbar />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/clients" element={<><PageBanner title="Clients" /><Clients /></>} />
          <Route path="/career" element={<><PageBanner title="Careers" /><Career /></>} />
          <Route path="/contact" element={<><PageBanner title="Contact" /><Contact /></>} />
          <Route path="/products" element={<><PageBanner title="Products" /><Products /></>} />
          <Route path="/services" element={<><PageBanner title="Services" /><Services /></>} />

          <Route path="/about-intro" element={<><PageBanner title="About Intro" /><AboutIntro /></>} />
          <Route path="/vision" element={<><PageBanner title="Vision & Mission" /><VisionMission /></>} />
          <Route path="/leadership" element={<><PageBanner title="Leadership" /><LeaderShip /></>} />
          <Route path="/ourcommitment" element={<><PageBanner title="Our Commitment" /><OurCommitment /></>} />
          <Route path="/valueprop" element={<><PageBanner title="Value Proposition" /><ValueProposition /></>} />

          <Route path="/geninfo" element={<><PageBanner title="Genomic Information" /><GenomicInformation /></>} />
          <Route path="/sanger" element={<><PageBanner title="SANGER SEQUENCING" /><SangerSequence /></>} />
          <Route path="/microbail" element={<><PageBanner title="MICROBIAL IDENTIFICATION (16S/18S rRNA Sequencing)" /><MicrobialIdentity /></>} />
          <Route path="/dnabarcod" element={<><PageBanner title="DNA Barcoding" /><DNABarcoding /></>} />
          <Route path="/genepres" element={<><PageBanner title="Gene Expression" /><GeneExpression /></>} />
          <Route path="/cattlegenot" element={<><PageBanner title="NGS SERVICES" /><CattleGenotyping /></>} />

          <Route path="/genesynthsis" element={<><PageBanner title="Genomic Synthesis" /><GeneSynthesis /></>} />
          <Route path="/unmdoligo" element={<><PageBanner title="Modified and Unmodified Oligos" /><UNModifiedOligo /></>} />
          <Route path="/mdoligo" element={<><PageBanner title="Modified Oligos" /><ModifiedOligo /></>} />
          <Route path="/dnaauth" element={<><PageBanner title="DNA Authenticity" /><DNAAuthenticity /></>} />
          <Route path="/sangerseq" element={<><PageBanner title="Nimagen Products" /><SangerSequenceing /></>} />
          <Route path="/reagentskits" element={<><PageBanner title="Reagents & Kits" /><ReagentsKits /></>} />
          <Route path="/seqordfrm" element={<><PageBanner title="GSI SEQUENCING ORDER FORM" /><SequenceOrderForm /></>} />
          <Route path="/midordfrm" element={<><PageBanner title="GSI MID ORDER FORM" /><GisMIDOrderForm /></>} />
          <Route path="/oligosordfrm" element={<><PageBanner title="GSI OLIGO SYNTHESIS ORDR FORM" /><OligosOrderForm /></>} />
          <Route path="/downloads" element={<><PageBanner title="Downloads" /><Downloads /></>} />

          <Route path="/newsupdates" element={<><PageBanner title="News & Updates" /><NewsUpdates /></>} />
          <Route path="/videogallry" element={<><PageBanner title="Video Gallery" /><VideoGallery /></>} />

          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
